module.exports = __webpack_public_path__ + "media/images/footer_page/claims/step3-46b5d4e92d04e841d870b0198dec1980.svg";